// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__POfH0","select":"styles_select__3ewMg"};